(ns app.front.view.pre-consultation.linked-workspaces
  (:require [app.domain.workspace.model :as workspace-model]
            [app.front.ui.section :as section]
            [app.front.ui.table :as ui-table]
            [app.front.view.workspace.related-workspace :as related-workspace]
            [app.front.view.workspace.subs :as ws-subs]
            [app.front.view.workspace.util :as ws-util]
            [core.front.event :refer [<sub]]
            [re-frame.core-instrumented :as rf]))

(rf/reg-sub ::workspaces
  :<- [::ws-subs/pre-consultation]
  (fn [pre-con _]
    (->> pre-con
         :workspace/_prior-pre-consultation
         (sort-by workspace-model/case-id)
         seq)))

(defn section []
  (when-let [workspaces (<sub [::workspaces])]
    (let [tr   (<sub [::ws-subs/tr])
          lang (<sub [:language])]
      [section/section
       :pre-con-linked-workspaces
       {:tr tr}
       :pre-consultation-linked-ws/section-heading
       [ui-table/modern-responsive-table
        {:items       workspaces
         :headerless? true
         :link        {:description ws-util/workspace-link-description
                       :make-href   ws-util/workspace-or-resume-application-href}
         :cols        [[nil
                        (partial related-workspace/workspace-id-col tr lang)
                        {}]
                       [nil
                        :workspace/address
                        {:width "25%"}]
                       [nil
                        (partial related-workspace/state-and-update-col tr)
                        {:width "275px"}]]}]])))
